<template>
  <v-row>
    <v-col cols="12">
      <v-form class="ma-6 pa-0">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dates"
                  label="Дата оплаты"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                range
                locale="ru-RU"
                :first-day-of-week="1"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Отмена
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(dates)">
                  Сохранить
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-select
              v-model="calcMethodSelect"
              :items="calcMethod"
              item-text="text"
              item-value="value"
              label="Способ расчета"
              outlined
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              v-model="payForSelect"
              :items="payFor"
              item-text="text"
              item-value="value"
              label="За что платим"
              outlined
            ></v-select>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="statObjSelect"
              :items="statObj"
              item-text="NAME"
              item-value="ID"
              label="Статья расхода"
              multiple
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="objSelect"
              :items="obj"
              item-text="NAME"
              item-value="ID"
              label="Объект"
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="contragentSelect"
              :items="contragentLists"
              item-text="TITLE"
              item-value="ID"
              label="Контрагент"
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-btn
          text
          color="success"
          class="mr-4"
          @click="getReport"
          :disabled="loading"
        >
          Сформировать
        </v-btn>
        <v-btn
          text
          color="orange"
          class="mr-4"
          @click="exportXls"
          :disabled="loading"
        >
          Выгрузить XLS
        </v-btn>
      </v-form>
    </v-col>
    <v-col>
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr class="gray">
                <th class="text-center">ID</th>
                <th class="text-center">Объект</th>
                <th class="text-center">Способ расчета</th>
                <th class="text-center">За что платим</th>
                <th class="text-center">Название счета</th>
                <th class="text-center">Дата создания счета</th>
                <th class="text-center">Cтатья расхода</th>
                <th class="text-center">Комментарий к статье расхода</th>
                <th class="text-center">Дата оплаты</th>
                <th class="text-center">Коэффициент</th>
                <th class="text-center">Сумма расходов</th>
                <th class="text-center">Сумма расходов без НДС</th>
                <th class="text-center">НДС</th>
              </tr>
            </thead>
            <template v-if="loading === true">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="light-green darken-4"
                height="10"
              ></v-progress-linear>
            </template>
            <tbody>
              <template v-for="item in itemsData">
                <tr :key="item.obj" class="blue">
                  <td></td>
                  <td>{{ item.obj }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ item.sumPay }}</td>
                  <td>{{ item.sumPayNoTax }}</td>
                  <td>{{ item.tax }}</td>
                </tr>
                <template v-for="paymethod in item.payMethod">
                  <tr :key="item.obj + paymethod.payMethodTitle" class="yellow">
                    <td></td>
                    <td></td>
                    <td>{{ paymethod.payMethodTitle }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{ paymethod.sumPay }}</td>
                    <td>{{ paymethod.sumPayNoTax }}</td>
                    <td>{{ paymethod.tax }}</td>
                  </tr>
                  <template v-for="payVariable in paymethod.payVariable">
                    <tr
                      :key="
                        item.obj +
                        paymethod.payMethodTitle +
                        payVariable.payVariableTitle
                      "
                      class="success"
                    >
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{{ payVariable.payVariableTitle }}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{{ payVariable.sumPay }}</td>
                      <td>{{ payVariable.sumPayNoTax }}</td>
                      <td>{{ payVariable.tax }}</td>
                    </tr>
                    <template v-for="invoice in payVariable.invoices">
                      <tr :key="invoice.id">
                        <td>{{ invoice.id }}</td>
                        <td>{{ invoice.contragent }}</td>
                        <td>{{ invoice.autor }}</td>
                        <td></td>
                        <td>{{ invoice.title }}</td>
                        <td>{{ invoice.createDate }}</td>
                        <td>{{ invoice.stat }}</td>
                        <td>{{ invoice.comments }}</td>
                        <td>{{ invoice.datePay }}</td>
                        <td>{{ invoice.coeff }}</td>
                        <td>{{ invoice.sumPay }}</td>
                        <td>{{ invoice.sumPayNoTax }}</td>
                        <td>{{ invoice.tax }}</td>
                      </tr>
                    </template>
                  </template>
                </template>
              </template>
              <tr class="orange">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Итого:</td>
                <td>{{ totalSumPay }}</td>
                <td>{{ totalSumPayNoTax }}</td>
                <td>{{ totalTax }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table v-show="itemsData.length == 1">
          <thead>
            <tr class="gray">
              <th class="text-center">Статья</th>
              <th class="text-center">Материалы</th>
              <th class="text-center">Техника</th>
              <th class="text-center">Работы</th>
              <th class="text-center">Прочее</th>
              <th class="text-center">Расходные материалы</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(stat, key) in stats" :key="key">
              <td class="text-center">{{ key }}</td>
              <td class="text-center">{{ stat.material }}</td>
              <td class="text-center">{{ stat.tech }}</td>
              <td class="text-center">{{ stat.works }}</td>
              <td class="text-center">{{ stat.other }}</td>
              <td class="text-center">{{ stat.materialOther }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import exeljs from "exceljs";
import fileWrite from "file-saver";

export default {
  name: "Home",
  data() {
    return {
      contragentLists: [],
      contragentSelect: "",
      loading: false,
      menu: false,
      coefList: {
        1061: "1,2",
        1063: "1,35",
        1561: "1",
        1611: "1,23457",
        1619: "1,25",
      },
      items: [],
      itemsData: [],
      stats: {},
      calcMethod: [
        { text: "Расчетный счет", value: "431" },
        { text: "Наличные", value: "429" },
      ],
      calcMethodSelect: "",
      payFor: [
        { text: "Материалы", value: "437" },
        { text: "Техника", value: "439" },
        {
          text: "Работы",
          value: "441",
        },
        { text: "Прочее", value: "443" },
        { text: "Расходные материалы", value: "1505" },
        { text: "Инструмент", value: "1649" },
      ],
      payForSelect: "",
      obj: [],
      objSelect: "",
      statObj: [],
      statObjSelect: "",
      dates: [],
      normalDate: [],
      reportData: [],
      exelData: [],
      totalSumPay: 0,
      totalSumPayNoTax: 0,
      totalTax: 0,
      totalSumPayXLS: 0,
      totalSumPayNoTaxXLS: 0,
      totalTaxXLS: 0,
      url: "https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/",
    };
  },
  methods: {
    pause(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async getObj() {
      try {
        this.obj = [];
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "97",
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const objData = await axios.post(this.url + method, params);
          next = objData.data.next;
          for (const elem of objData.data.result) {
            this.obj.push(elem);
          }
          if (!next) {
            i = 0;
          }
        }
        //console.log(this.obj)
        this.obj.sort((a, b) => {
          if (a["NAME"] < b["NAME"]) {
            return -1;
          }
          if (a["NAME"] > b["NAME"]) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getStatObj() {
      try {
        console.log("getStatObj");
        try {
          this.statObj = ["", "Зарплата_"];
          const params = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: "97",
            ELEMENT_ID: this.objSelect,
          };
          const method = "lists.element.get";
          const objData = await axios.post(this.url + method, params);
          console.log({ objData });
          const statObjData = Object.values(
            objData.data.result[0].PROPERTY_891,
          )[0];
          for (const stat of statObjData.split(";")) {
            let pushStat = stat.replace("__", "");
            pushStat = pushStat.trim();
            if (pushStat != " " || pushStat != "") this.statObj.push(pushStat);
          }
          console.log(this.statObj);
          this.statObj.sort((a, b) => {
            if (a["NAME"] < b["NAME"]) {
              return -1;
            }
            if (a["NAME"] > b["NAME"]) {
              return 1;
            }
            // a должно быть равным b
            return 0;
          });
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getContragents() {
      try {
        this.contragentLists = [];
        const params = {
          order: { TITLE: "ASC" },
          filter: {},
          select: ["ID", "TITLE"],
        };
        const method = "crm.company.list";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const contragentData = await axios.post(this.url + method, params);
          next = contragentData.data.next;
          for (const elem of contragentData.data.result) {
            this.contragentLists.push(elem);
          }
          if (!next) {
            i = 0;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getReport() {
      try {
        this.stats = {};
        this.loading = true;
        this.itemsData = [];
        this.items = [];
        this.normalDate = [];
        this.totalSumPay = 0;
        this.totalSumPayNoTax = 0;
        this.totalTax = 0;
        this.totalSumPayXLS = 0;
        this.totalSumPayNoTaxXLS = 0;
        this.totalTaxXLS = 0;

        const propertyValue = (elem) => (elem ? Object.values(elem)[0] : 0);
        console.log("test 1234");

        await this.normalizeDate();
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "45",
          FILTER: {
            ">=PROPERTY_691": this.normalDate[0],
            "<=PROPERTY_691": this.normalDate[1],
          },
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        console.log({ params });

        while (i > 0) {
          params.start = next;
          if (this.objSelect) params["FILTER"]["PROPERTY_973"] = this.objSelect;
          if (this.calcMethodSelect)
            params["FILTER"]["PROPERTY_573"] = this.calcMethodSelect;
          if (this.payForSelect)
            params["FILTER"]["PROPERTY_593"] = this.payForSelect;
          if (this.contragentSelect) {
            params["FILTER"]["PROPERTY_1019"] = this.contragentSelect;
            this.isPayInvoice = false;
          }
          console.log(params);
          const reportData = await axios.post(this.url + method, params);
          console.log(reportData);
          next = reportData.data.next;
          for (const elem of reportData.data.result) {
            if (
              elem["NAME"] === "Входящий счет" ||
              elem["NAME"] === "Выдача наличных средств" ||
              elem["NAME"] === "Согласование и оплата расходов (Нал/Безнал)" ||
              elem["NAME"].indexOf("Счет по заявке") > -1
            ) {
              console.log({ elem });
              const item = {
                id: elem["ID"],
                idInvoice: elem["PROPERTY_997"]
                  ? Object.values(elem["PROPERTY_997"])[0]
                  : "",
                obj: "",
                payMethod: "",
                payVariable: "",
                title: elem["NAME"],
                createDate: elem["DATE_CREATE"],
                coeff: elem["PROPERTY_723"]
                  ? this.coefList[propertyValue(elem["PROPERTY_723"])]
                  : "",
                comments: elem["PREVIEW_TEXT"] ? elem["PREVIEW_TEXT"] : "",
                stat: elem["PROPERTY_581"]
                  ? propertyValue(elem["PROPERTY_581"]).split(",")[0].trim()
                  : "",
                datePay: elem["PROPERTY_691"]
                  ? propertyValue(elem["PROPERTY_691"])
                  : "",
                sumPay: 0,
                sumPayNoTax: 0,
                tax: 0,
                sumPayXLS: elem["PROPERTY_589"]
                  ? Number(propertyValue(elem["PROPERTY_591"]))
                  : "",
                sumPayNoTaxXLS: elem["PROPERTY_589"]
                  ? Number(propertyValue(elem["PROPERTY_587"]))
                  : "",
                taxXLS: elem["PROPERTY_589"]
                  ? Number(propertyValue(elem["PROPERTY_589"]))
                  : "",
                contragent: "",
                contragentID: "",
                autor: elem["CREATED_USER_NAME"].split(")")[1],
              };
              if (elem["PROPERTY_1019"]) {
                if (Object.values(elem["PROPERTY_1019"])[0].trim() != "") {
                  if (
                    Object.values(elem["PROPERTY_1019"])[0].substr(0, 2) == "CO"
                  ) {
                    item.contragentID = Object.values(
                      elem["PROPERTY_1019"],
                    )[0].substr(3);
                  } else {
                    item.contragentID = Object.values(elem["PROPERTY_1019"])[0];
                  }
                }
              }
              if (elem["PROPERTY_973"]) {
                const obj = this.obj.find(
                  (e) => e.ID == Object.values(elem["PROPERTY_973"])[0],
                );

                item.obj = obj ? obj.NAME : "";
              }
              if (elem["PROPERTY_573"]) {
                item.payMethod = this.calcMethod.filter((e) => {
                  return e.value == Object.values(elem["PROPERTY_573"])[0];
                })[0].text;
              }
              if (elem["PROPERTY_593"]) {
                item.payVariable = this.payFor.filter((e) => {
                  return e.value == Object.values(elem["PROPERTY_593"])[0];
                })[0].text;
              }
              if (elem["PROPERTY_591"])
                item.sumPay = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(Object.values(elem["PROPERTY_591"]));
              if (elem["PROPERTY_587"])
                item.sumPayNoTax = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(Object.values(elem["PROPERTY_587"]));
              if (elem["PROPERTY_589"])
                item.tax = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(Object.values(elem["PROPERTY_589"]));
              console.log({ item });
              if (this.statObjSelect.length > 0) {
                const normalizeForCompare = (str) => {
                  if (!str) return "";
                  return str
                    .toLowerCase()
                    .replace(/[.,():;]/g, "")
                    .trim();
                };

                const isNeed = this.statObjSelect.findIndex((e) => {
                  const searchStr = normalizeForCompare(e);
                  const statStr = normalizeForCompare(item.stat);
                  const firstPartStr = normalizeForCompare(
                    item.stat.split(",")[0],
                  );

                  return (
                    searchStr.includes(statStr) ||
                    searchStr.includes(firstPartStr)
                  );
                });
                if (isNeed > -1) {
                  this.items.push(item);
                }
              } else {
                this.items.push(item);
              }
            }
          }
          if (!next) {
            i = 0;
          }
        }
        const batchParams = {
          halt: 0,
          cmd: {},
        };
        console.log(this.items.length);
        for (const index in this.items) {
          console.log(
            `index=${index}&contragentID=${this.items[index].contragentID}`,
          );
          //console.log(this.items[index].contragentID, 'id')
          batchParams.cmd[
            index
          ] = `crm.company.get?id=${this.items[index].contragentID}`;
          if (index % 50 == 0 || index == Number(this.items.length) - 1) {
            console.log(batchParams, "batchParams");
            const batchResult = await axios.post(
              this.url + "batch",
              batchParams,
            );
            console.log(batchResult.data.result.result, "batchRes");
            for (const elemBatchindex in batchResult.data.result.result) {
              this.items[elemBatchindex].contragent =
                batchResult.data.result.result[elemBatchindex].TITLE;
            }
            batchParams.cmd = {};
          }
        }
        this.formatReport(this.items);
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    formatReport(data) {
      for (const obj of this.obj) {
        const result = data.filter((e) => {
          return e["obj"] == obj["NAME"];
        });

        if (result.length > 0) {
          const item = {
            obj: obj["NAME"],
            payMethod: {},
            sumPay: 0,
            sumPayNoTax: 0,
            tax: 0,
            stats: {},
            sumPayXLS: 0,
            sumPayNoTaxXLS: 0,
            taxXLS: 0,
          };
          for (const objInvoice of result) {
            if (this.objSelect) {
              console.log(objInvoice.stat, "objInvoice.stat");
              if (objInvoice.stat) {
                if (!this.stats[objInvoice.stat.trim()]) {
                  this.stats[objInvoice.stat.trim()] = {
                    material: 0,
                    materialXLS: 0,
                    tech: 0,
                    techXLS: 0,
                    works: 0,
                    worksXLS: 0,
                    other: 0,
                    otherXLS: 0,
                    materialOther: 0,
                    materialOtherXLS: 0,
                  };
                }
              }
              console.log({ objInvoice });
              switch (objInvoice.payVariable) {
                case "Материалы":
                  this.stats[objInvoice.stat.trim()].materialXLS += Number(
                    objInvoice.sumPayXLS,
                  );
                  break;
                case "Техника":
                  this.stats[objInvoice.stat.trim()].techXLS += Number(
                    objInvoice.sumPayXLS,
                  );
                  break;
                case "Работы":
                  this.stats[objInvoice.stat.trim()].worksXLS += Number(
                    objInvoice.sumPayXLS,
                  );
                  break;
                case "Прочее":
                  this.stats[objInvoice.stat.trim()].otherXLS += Number(
                    objInvoice.sumPayXLS,
                  );
                  break;
                case "Расходные материалы":
                  this.stats[objInvoice.stat.trim()].materialOtherXLS += Number(
                    objInvoice.sumPayXLS,
                  );
                  break;
              }
            }

            let payMethodIndex = "";
            let payVariableIndex = "";

            if (objInvoice.payMethod === "Расчетный счет")
              payMethodIndex = "invoice";
            else payMethodIndex = "cash";
            switch (objInvoice.payVariable) {
              case "Материалы":
                payVariableIndex = "material";
                break;
              case "Техника":
                payVariableIndex = "technical";
                break;
              case "Работы":
                payVariableIndex = "works";
                break;
              case "Прочее":
                payVariableIndex = "other";
                break;
              case "Расходные материалы":
                payVariableIndex = "materialOther";
                break;
            }
            if (item.payMethod[payMethodIndex]) {
              item.payMethod[payMethodIndex].sumPay += Number(
                objInvoice.sumPayXLS,
              );
              item.payMethod[payMethodIndex].sumPayNoTax += Number(
                objInvoice.sumPayNoTaxXLS,
              );
              item.payMethod[payMethodIndex].tax += Number(objInvoice.taxXLS);
              item.payMethod[payMethodIndex].sumPayXLS += Number(
                objInvoice.sumPayXLS,
              );
              item.payMethod[payMethodIndex].sumPayNoTaxXLS += Number(
                objInvoice.sumPayNoTaxXLS,
              );
              item.payMethod[payMethodIndex].taxXLS += Number(
                objInvoice.taxXLS,
              );
            } else {
              item.payMethod[payMethodIndex] = {};
              item.payMethod[payMethodIndex].payVariable = {};
              item.payMethod[payMethodIndex].payMethodTitle =
                objInvoice.payMethod;
              item.payMethod[payMethodIndex].sumPay = Number(
                objInvoice.sumPayXLS,
              );
              item.payMethod[payMethodIndex].sumPayNoTax = Number(
                objInvoice.sumPayNoTaxXLS,
              );
              item.payMethod[payMethodIndex].tax = Number(objInvoice.taxXLS);
              item.payMethod[payMethodIndex].sumPayXLS = Number(
                objInvoice.sumPayXLS,
              );
              item.payMethod[payMethodIndex].sumPayNoTaxXLS = Number(
                objInvoice.sumPayNoTaxXLS,
              );
              item.payMethod[payMethodIndex].taxXLS = Number(objInvoice.taxXLS);
            }
            if (item.payMethod[payMethodIndex].payVariable[payVariableIndex]) {
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].invoices.push(objInvoice);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPay += Number(objInvoice.sumPayXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPayNoTax += Number(objInvoice.sumPayNoTaxXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].tax += Number(objInvoice.taxXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPayXLS += Number(objInvoice.sumPayXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPayNoTaxXLS += Number(objInvoice.sumPayNoTaxXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].taxXLS += Number(objInvoice.taxXLS);
            } else {
              item.payMethod[payMethodIndex].payVariable[payVariableIndex] = {};
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].payVariableTitle = objInvoice.payVariable;
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].invoices = [objInvoice];
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPay = Number(objInvoice.sumPayXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPayNoTax = Number(objInvoice.sumPayNoTaxXLS);
              item.payMethod[payMethodIndex].payVariable[payVariableIndex].tax =
                Number(objInvoice.taxXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPayXLS = Number(objInvoice.sumPayXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPayNoTaxXLS = Number(objInvoice.sumPayNoTaxXLS);
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].taxXLS = Number(objInvoice.taxXLS);
            }
            item.sumPayXLS += Number(objInvoice.sumPayXLS);
            item.sumPayNoTaxXLS += Number(objInvoice.sumPayNoTaxXLS);
            item.taxXLS += Number(objInvoice.taxXLS);
            item.sumPay += Number(objInvoice.sumPayXLS);
            item.sumPayNoTax += Number(objInvoice.sumPayNoTaxXLS);
            item.tax += Number(objInvoice.taxXLS);

            this.totalSumPay += Number(objInvoice.sumPayXLS);
            this.totalSumPayNoTax += Number(objInvoice.sumPayNoTaxXLS);
            this.totalTax += Number(objInvoice.taxXLS);
            this.totalSumPayXLS += Number(objInvoice.sumPayXLS);
            this.totalSumPayNoTaxXLS += Number(objInvoice.sumPayNoTaxXLS);
            this.totalTaxXLS += Number(objInvoice.taxXLS);
          }

          for (const payMethodIndex in item.payMethod) {
            item.payMethod[payMethodIndex].sumPay = new Intl.NumberFormat(
              "ru-RU",
              {
                minimumFractionDigits: 2,
              },
            ).format(item.payMethod[payMethodIndex].sumPay);
            item.payMethod[payMethodIndex].sumPayNoTax = new Intl.NumberFormat(
              "ru-RU",
              {
                minimumFractionDigits: 2,
              },
            ).format(item.payMethod[payMethodIndex].sumPayNoTax);
            item.payMethod[payMethodIndex].tax = new Intl.NumberFormat(
              "ru-RU",
              {
                minimumFractionDigits: 2,
              },
            ).format(item.payMethod[payMethodIndex].tax);
            for (const payVariableIndex in item.payMethod[payMethodIndex]
              .payVariable) {
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPay = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(
                item.payMethod[payMethodIndex].payVariable[payVariableIndex]
                  .sumPay,
              );
              item.payMethod[payMethodIndex].payVariable[
                payVariableIndex
              ].sumPayNoTax = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(
                item.payMethod[payMethodIndex].payVariable[payVariableIndex]
                  .sumPayNoTax,
              );
              item.payMethod[payMethodIndex].payVariable[payVariableIndex].tax =
                new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(
                  item.payMethod[payMethodIndex].payVariable[payVariableIndex]
                    .tax,
                );
            }
          }
          item.sumPay = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(item.sumPay);
          item.sumPayNoTax = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(item.sumPayNoTax);
          item.tax = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(item.tax);
          //console.log(item, 'item')
          console.log(item.stats, "stats");

          this.itemsData.push(item);
        }
      }
      this.totalSumPay = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(this.totalSumPay);
      this.totalSumPayNoTax = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(this.totalSumPayNoTax);
      this.totalTax = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(this.totalTax);

      if (this.objSelect) {
        for (const statIndex in this.stats) {
          console.log(this.stats[statIndex]);
          this.stats[statIndex].material = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.stats[statIndex].materialXLS);
          this.stats[statIndex].tech = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.stats[statIndex].techXLS);
          this.stats[statIndex].works = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.stats[statIndex].worksXLS);
          this.stats[statIndex].other = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.stats[statIndex].otherXLS);
          this.stats[statIndex].materialOther = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.stats[statIndex].materialOtherXLS);
        }
      }
      //console.log(this.itemsData, 'report')
      this.loading = false;
    },
    async exportXls() {
      try {
        const workbook = new exeljs.Workbook();
        workbook.views = [
          {
            x: 0,
            y: 500,
            width: 29040,
            height: 15840,
            visibility: "visible",
          },
        ];
        const worksheet = workbook.addWorksheet("Отчет по объектам");
        worksheet.columns = [
          { header: "Контрагент", key: "contragent", width: 19 },
          { header: "Объект", key: "obj", width: 19 },
          { header: "Способ расчета", key: "payMethod", width: 19 },
          { header: "За что платим", key: "payVariable", width: 19 },
          { header: "ID", key: "id", width: 12, style: { numFmt: 0 } },
          { header: "Название счета", key: "title", width: 19 },
          {
            header: "Дата создания счета",
            key: "createDate",
            width: 17,
            style: { numFmt: "dd/mm/yyyy" },
          },
          { header: "Cтатьz расхода", key: "stat", width: 17 },
          {
            header: "Комментарий к статье расхода",
            key: "comments",
            width: 17,
          },
          {
            header: "Дата оплаты",
            key: "datePay",
            width: 17,
            style: { numFmt: "dd/mm/yyyy" },
          },
          {
            header: "Коэффициент",
            key: "coeff",
            width: 17,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Сумма расходов",
            key: "sumPayXLS",
            width: 17,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Сумма расходов без НДС",
            key: "sumPayNoTaxXLS",
            width: 17,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "НДС",
            key: "taxXLS",
            width: 17,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "",
            key: "materialOther",
            width: 17,
            style: { numFmt: "#,0.00" },
          },
        ];

        for (const item of this.itemsData) {
          const firstRow = {
            obj: item.obj,
            sumPayXLS: item.sumPayXLS,
            sumPayNoTaxXLS: item.sumPayNoTaxXLS,
            taxXLS: item.taxXLS,
          };
          const objRow = worksheet.addRow(firstRow);
          objRow.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "B9B7BD" },
          };
          objRow.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          for (const payMethod in item.payMethod) {
            const twoRow = {
              payMethod: item.payMethod[payMethod].payMethodTitle,
              sumPayXLS: item.payMethod[payMethod].sumPayXLS,
              sumPayNoTaxXLS: item.payMethod[payMethod].sumPayNoTaxXLS,
              taxXLS: item.payMethod[payMethod].taxXLS,
            };
            const payMetodRow = worksheet.addRow(twoRow);
            payMetodRow.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "B6E2D3" },
            };
            payMetodRow.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            for (const payVariable in item.payMethod[payMethod].payVariable) {
              const treeRow = {
                payVariable:
                  item.payMethod[payMethod].payVariable[payVariable]
                    .payVariableTitle,
                sumPayXLS:
                  item.payMethod[payMethod].payVariable[payVariable].sumPayXLS,
                sumPayNoTaxXLS:
                  item.payMethod[payMethod].payVariable[payVariable]
                    .sumPayNoTaxXLS,
                taxXLS:
                  item.payMethod[payMethod].payVariable[payVariable].taxXLS,
              };
              const payVariableRow = worksheet.addRow(treeRow);
              payVariableRow.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "EED6D3" },
              };
              payVariableRow.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
              for (const invoice of item.payMethod[payMethod].payVariable[
                payVariable
              ].invoices) {
                const fourRow = {
                  id: invoice.id,
                  obj: invoice.contragent,
                  payMethod: invoice.autor,
                  title: invoice.title,
                  coeff: invoice.coeff,
                  createDate: invoice.createDate,
                  comments: invoice.comments,
                  stat: invoice.stat,
                  datePay: invoice.datePay,
                  sumPayXLS: invoice.sumPayXLS,
                  sumPayNoTaxXLS: invoice.sumPayNoTaxXLS,
                  taxXLS: invoice.taxXLS,
                };
                const invoiceRow = worksheet.addRow(fourRow);
                invoiceRow.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              }
            }
          }
        }
        const total = worksheet.addRow({
          coeff: "ИТОГО: ",
          sumPayXLS: this.totalSumPayXLS,
          sumPayNoTaxXLS: this.totalSumPayNoTaxXLS,
          taxXLS: this.totalTaxXLS,
        });
        const totalRow = (total.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "59981A" },
        });
        totalRow.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        worksheet.addRow({});
        const headerRow = worksheet.addRow({
          comments: "Наименование",
          coeff: "Материал",
          sumPayXLS: "Техника",
          sumPayNoTaxXLS: "Работы",
          taxXLS: "Прочее",
          materialOther: "Расходные материалы",
        });

        headerRow.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        if (this.objSelect) {
          for (const stat in this.stats) {
            const statRow = worksheet.addRow({
              comments: stat,
              coeff: this.stats[stat].materialXLS,
              sumPayXLS: this.stats[stat].techXLS,
              sumPayNoTaxXLS: this.stats[stat].worksXLS,
              taxXLS: this.stats[stat].otherXLS,
              materialOther: this.stats[stat].materialOtherXLS,
            });

            statRow.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          }
        }
        const buffer = await workbook.xlsx.writeBuffer();
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([buffer], { type: fileType });
        fileWrite(blob, "report.xlsx");
      } catch (e) {
        console.log(e);
      }
    },
    async normalizeDate() {
      try {
        const firstDate = this.dates[0].split("-");
        const twoDate = this.dates[1].split("-");
        const firstDateFormated =
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0] + " 00:00:00";
        const twoDateFormated =
          twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
        this.normalDate.push(firstDateFormated);
        this.normalDate.push(twoDateFormated);
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    objSelect(newObj, oldObj) {
      if (newObj !== oldObj) {
        this.getStatObj();
      }
    },
  },
  mounted() {
    this.getObj();
    this.getContragents();
  },
};
</script>
